import { API_ERROR_CODES } from 'src/consts';

export const RateLimitedError = () => (
  <>
    Please try again in 15 minutes.
    <br />
    You&#8217;ve attempted this action too many times recently.
  </>
);

export const AttemptingToUsePreviouslyUsedPasswordError = () => <>You cannot use your current password.</>;

export const AttemptingToUseBadPassword = () => (
  <>
    Please choose a more secure password.
    <br />
    Try increasing length or including numbers and symbols.
  </>
);

export const AttemptingToUseExpiredLink = () => (
  <>
    The password reset link you followed was expired.
    <br />
    Please check your email, as we&#8217;ve sent you a new link
  </>
);

/**
 * Checks to see if the error being returned is an "invalid token" error.
 *
 * @param error
 * @returns {bool}
 */
export function getIsInvalidTokenError(error: any) {
  if (
    error?.message?.startsWith('Invalid code provided') ||
    error?.title === 'Unauthorized' ||
    error?.code === 'ExpiredCodeException' ||
    error?.code === 'CodeMismatchException'
  ) {
    return true;
  }

  const errors: { code?: string }[] | undefined = error?.response?.data?.errors;
  const isInvalidToken =
    errors?.some(item => item?.code === API_ERROR_CODES.account_password_change_token_is_invalid) ?? false;

  return isInvalidToken;
}

/**
 * A generic error message that appears when a customer
 * encounters an error while trying to change their password
 * @returns {ReactNode}
 */
export const GenericPasswordError = () => (
  <>
    Please try again or contact us at <a href="tel:+12126753900">(212) 675-3900</a> for further assistance.
  </>
);
